import React from 'react';
import { motion } from 'framer-motion';
import { Icon, Input, Button } from '../ui';

export default function NewsletterSection() {
  const [email, setEmail] = React.useState('');
  const [sent, setSent] = React.useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setSent(true);
      setEmail('');
      setTimeout(() => setSent(false), 3000);
    }
  };

  return (
    <section className="mb-32 max-w-3xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-gradient-to-br from-slate-900/60 to-indigo-900/20 backdrop-blur-xl border border-slate-700/50 rounded-3xl p-10 text-center"
      >
        <Icon name="IconMail" size={40} className="mx-auto mb-6 text-indigo-400" />
        <h2 className="text-3xl font-bold text-white mb-4">Restez informé</h2>
        <p className="text-slate-400 mb-8 max-w-lg mx-auto">
          Recevez les dernières actualités fiscales et mises à jour de la plateforme.
        </p>
        <form onSubmit={handleSubmit} className="flex gap-3 max-w-md mx-auto">
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Votre email professionnel"
            required
            className="bg-slate-800/50 border-slate-600 text-white placeholder:text-slate-500 flex-1"
          />
          <Button type="submit" className="px-6">
            {sent ? (
              <><Icon name="IconCheck" size={16} /> Envoyé</>
            ) : (
              <><Icon name="IconSend" size={16} /> S'abonner</>
            )}
          </Button>
        </form>
      </motion.div>
    </section>
  );
}
